// Auth
export const AUTH_URLS = {
  LOGIN: 'LOGIN',
};
// User
export const USER_URLS = {
  USER_ME: 'USER_ME',
};
//Unit
export const UNIT = {
  API_RESOURCE: 'unit',
};
//Tax Head
export const TAXHEAD = {
  API_RESOURCE: 'tax-head',
};
//Category
export const CATEGORY = {
  API_RESOURCE: 'categorys',
};

//Profile
export const PROFILE = {
  API_RESOURCE: 'brand',
};
export const PRODUCT_OR_SERVICE = {
  API_RESOURCE: 'products-or-services',
};
//Job Card
export const JOB_CARD = {
  API_RESOURCE: 'job-cards',
};

//Branch
export const BRANCH = {
  API_RESOURCE: 'branch',
};
//Service and Item Mapping
export const SERVICE_AND_ITEM_MAPPING = {
  API_RESOURCE: 'service_item_mappings',
};
//Staff
export const STAFF = {
  API_RESOURCE: 'staffs',
};
//Role
export const ROLES = {
  API_RESOURCE: 'roles',
};
//Purchase
export const PURCHASE = {
  API_RESOURCE: 'purchase',
};
//  Customer

export const CUSTOMERS = {
  API_RESOURCE: 'customers',
};

//Customer List
export const CUSTOMERLIST = {
  API_RESOURCE: 'customers',
};
export const INVOICE = {
  API_RESOURCE: 'invoice',
};
export const SERVICE_ITEM_USAGE = {
  API_RESOURCE: 'SERVICE_ITEM_USAGE',
};
export const JOB_SERVICE_ACTION = {
  API_RESOURCE: 'JOB_SERVICE_ACTION',
};

export const DASHBOARD_TOP_PERFORMER = {
  API_RESOURCE: 'dashborad/top-performers',
};
export const STAFF_TRANSFER = {
  API_RESOURCE: 'stafftransferrequest',
};

export const DASHBOARD_TODAYS_APPOINTMENT = {
  API_RESOURCE: 'dashboard/todays-apponintment',
};

export const DASHBOARD_TOTAL_EARNINGS = {
  API_RESOURCE: 'dashboard/get-total-earnings',
};

export const DASHBOARD_LOW_STOCK_PRODUCTS = {
  API_RESOURCE: 'dashboard/low-stock-products',
};

// URLS
export const URLS: Record<string, string> = {
  [AUTH_URLS.LOGIN]: '/user/login',
  [UNIT.API_RESOURCE]: 'units',
  [TAXHEAD.API_RESOURCE]: 'tax-heads',
  [CATEGORY.API_RESOURCE]: 'categorys',
  [PROFILE.API_RESOURCE]: 'brand',
  [PRODUCT_OR_SERVICE.API_RESOURCE]: 'products-or-services',
  [JOB_CARD.API_RESOURCE]: 'job-cards',
  [BRANCH.API_RESOURCE]: 'branches',
  [SERVICE_AND_ITEM_MAPPING.API_RESOURCE]: 'service_item_mappings',
  [STAFF.API_RESOURCE]: 'staffs',
  [ROLES.API_RESOURCE]: 'roles',
  [PURCHASE.API_RESOURCE]: 'purchase-entry',
  [CUSTOMERS.API_RESOURCE]: 'customers',
  [INVOICE.API_RESOURCE]: 'invoices',
  [SERVICE_ITEM_USAGE.API_RESOURCE]: 'job_service_item_usages',
  [JOB_SERVICE_ACTION.API_RESOURCE]: 'job-service/action',
  [DASHBOARD_TOP_PERFORMER.API_RESOURCE]: 'dashboard/top-performers',
  [STAFF_TRANSFER.API_RESOURCE]:'stafftransferrequest',
  [DASHBOARD_TODAYS_APPOINTMENT.API_RESOURCE]: 'dashboard/todays-apponintment',
  [DASHBOARD_TOTAL_EARNINGS.API_RESOURCE]: 'dashboard/get-total-earnings',
  [DASHBOARD_LOW_STOCK_PRODUCTS.API_RESOURCE]: 'dashboard/low-stock-products'
};
